import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { MobileNavLink } from '../MobileNavMenuData';

const drafts = {
  title: 'Your Drafts + Orders',
  path: '/wedding-albums/drafts',
};
const all = { title: 'See All Albums', path: '/wedding-albums/shop' };
const classic = {
  title: 'Classic Album',
  path: '/wedding-albums/select?album_type=classic',
};
const premier = {
  title: 'Premier Album',
  path: '/wedding-albums/select?album_type=premier',
};
const deluxe = {
  title: 'Deluxe Album',
  path: '/wedding-albums/select?album_type=deluxe',
};

export default function getMobileAlbumsMenuData(userContext: UserContext): MobileNavLink[][] {
  const isActiveAlbumsUser = Boolean(
    userContext.invitation_account?.photobooks_onboarding_completed
  );
  if (isActiveAlbumsUser) {
    return [[drafts], [all, classic, premier, deluxe]];
  }
  return [[all, classic, premier, deluxe]];
}
